import { Badge } from 'cpool-components/general/Badge';
import { COLORS } from 'cpool-components/types';
import type { RESIDUAL_DEBT_INSURANCE } from 'cpool-constants';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
    isSecondApplicant: boolean;
    hasSecondApplicant: boolean;
};

export const HeaderNotification: React.FC<Props> = ({ hasSecondApplicant, isSecondApplicant }) => {
    const { t } = useTranslation();
    const insurancesData = useWatch({
        name: `restschuldversicherung.${isSecondApplicant ? 'applicant2' : 'applicant1'}`,
    });
    const insurances: Array<RESIDUAL_DEBT_INSURANCE | 'NONE'> = [];
    if (insurancesData?.death.existing) insurances.push('DEATH');
    if (insurancesData?.workIncapacity.existing) insurances.push('WORK_INCAPACITY');
    if (insurancesData?.unemployment.existing) insurances.push('UNEMPLOYMENT');

    if (insurances.length === 0) insurances.push('NONE');

    return (
        <Badge color={COLORS.WHITE}>
            {hasSecondApplicant &&
                t(
                    `BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.HEADER_NOTIFICATIONS.${
                        isSecondApplicant ? 'SECOND_APPLICANT' : 'FIRST_APPLICANT'
                    }`,
                )}
            {insurances
                .map((insurance) => t(`BANK_CREDIT_REQUEST.RESIDUAL_DEBT_INSURANCE.HEADER_NOTIFICATIONS.${insurance}`))
                .join(', ')}
        </Badge>
    );
};
